import { call, put } from 'redux-saga/effects';

import api from 'api';
import { IGetAccessCodeResponse } from 'api/components/Auth/types';

import { sendAnalyticAccessCodeError } from 'services/Analytics/trackers/accessCode';

import { LS_KEYS } from 'helpers/localStorage';

import { getAppAccessCodeFailure, getAppAccessCodeSuccess } from '../actions';

export function* getAppAccessCodeSaga() {
    try {
        const payload: IGetAccessCodeResponse = yield call(api.auth.getAppAccessCode);

        yield put(getAppAccessCodeSuccess(payload));

        localStorage.setItem(LS_KEYS.appAccessCode, JSON.stringify(payload));
    } catch (error: any) {
        yield put(getAppAccessCodeFailure());
        yield call(sendAnalyticAccessCodeError, error.message || 'Error fetching access code');
    }
}
